import AddFile from './AddFile';

export default AddFile;
